
// src/rbac/RouteGuards.js
import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "./rbac/AuthContext";

export function ProtectedRoute({ allowedRoles, children }) {
  const { loading, currentUser, role } = useAuth();

  if (loading) return <div className="p-3">Loading session…</div>;
  if (!currentUser) return <Navigate to="/login" replace />;
  if (!allowedRoles.includes(role)) return <div className="p-3">Access Denied</div>;

  return children;
}

/** Ensures managers/residents only access THEIR community; admins bypass */
export function CommunityGuard({ children }) {
  const { loading, isAdmin, communities, primaryCommunityId } = useAuth();
  const { communityId } = useParams();

  if (loading) return <div className="p-3">Loading session…</div>;
  if (isAdmin) return children; // admins can access all

  // Allow if the ID matches primary or is included
  const allowed =
    communityId &&
    (communityId === primaryCommunityId || communities.includes(communityId));

  if (!allowed) return <div className="p-3">Access Denied: not your community.</div>;
  return children;
}
